import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const TYPE = 'type'
const STATUS = 'status'
const SHOULD_NOTIFY = 'should_notify'
const STUDENT = 'student'
const FACILITATOR = 'facilitator'
const NOTE_TAKER = 'note_taker'
const LOCATION = 'location'
const PURPOSE = 'purpose'
const MEETING_URL = 'meeting_url'
const AGENDA = 'agenda'
const START_DATETIME = 'start_datetime'
const DURATION_MINUTES = 'duration_minutes'
const MEETING_CATEGORY = 'meeting_category'
const PARTICIPANTS = 'participants'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [TYPE]: {
      label: `${t('common.type')}`,
      name: TYPE,
      required: true,
    },
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
      required: true,
    },
    [FACILITATOR]: {
      label: `${t('meetings.facilitator')}`,
      name: FACILITATOR,
      required: true,
    },
    [NOTE_TAKER]: {
      label: `${t('meetings.note-taker')}`,
      name: NOTE_TAKER,
      required: true,
    },
    [SHOULD_NOTIFY]: {
      label: `${t('meetings.should-notify')}`,
      name: SHOULD_NOTIFY,
      required: true,
    },
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [LOCATION]: {
      label: `${t('meetings.location')}`,
      name: LOCATION,
      required: true,
    },
    [PURPOSE]: {
      label: `${t('meetings.purpose')}`,
      name: PURPOSE,
      required: true,
    },
    [MEETING_URL]: {
      label: `${t('meetings.meeting-url')}`,
      name: MEETING_URL,
    },
    [AGENDA]: {
      label: `${t('meetings.agenda')}`,
      name: AGENDA,
    },
    [START_DATETIME]: {
      label: `${t('common.start-time')}`,
      name: START_DATETIME,
      required: true,
    },
    [DURATION_MINUTES]: {
      label: `${t('common.duration-minutes')}`,
      name: DURATION_MINUTES,
      required: true,
    },
    [MEETING_CATEGORY]: {
      label: `${t('meetings.meeting-category')}`,
      name: MEETING_CATEGORY,
      required: true,
    },
    [PARTICIPANTS]: {
      label: `${t('meetings.participant')}`,
      name: PARTICIPANTS,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TYPE]: null,
  [STATUS]: null,
  [SHOULD_NOTIFY]: false,
  [STUDENT]: null,
  [FACILITATOR]: {},
  [NOTE_TAKER]: {},
  [LOCATION]: '',
  [PURPOSE]: '',
  [MEETING_URL]: '',
  [AGENDA]: '',
  [START_DATETIME]: null,
  [DURATION_MINUTES]: '',
  [MEETING_CATEGORY]: null,
  [PARTICIPANTS]: [
    {
      participant: {id: '', title: ''},
      user_id: '',
      email: '',
      role: '',
      phone: '',
      has_attended: false
    },
  ],
}

/**
 * Form data validation
 */
export const validationSchema = (userRole: string) =>
  yup.object().shape({
    [TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [STATUS]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [SHOULD_NOTIFY]: yup.boolean().required(`${t('errors.required-error-message')}`),
    [STUDENT]: yup.object().nullable(),
    [FACILITATOR]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [NOTE_TAKER]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [LOCATION]: yup.string().required(`${t('errors.required-error-message')}`),
    [PURPOSE]: yup.string().required(`${t('errors.required-error-message')}`),
    [MEETING_URL]: yup.string(),
    [AGENDA]: yup.string(),
    [START_DATETIME]: yup
      .date()
      .nullable()
      .min(today, `${t('errors.past-date', {type: 'Start time'})}`)
      .required(`${t('errors.required-error-message')}`),
    [DURATION_MINUTES]: yup.number().required(`${t('errors.required-error-message')}`),
    [MEETING_CATEGORY]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [PARTICIPANTS]: yup
      .array()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
